var map = {
	"./404.svg": "49be",
	"./build.svg": "b88c",
	"./button.svg": "c292",
	"./cascader.svg": "737d",
	"./chart.svg": "20e7",
	"./clipboard.svg": "5aa7",
	"./color.svg": "e218",
	"./component.svg": "02b8",
	"./dashboard.svg": "7154",
	"./date-range.svg": "ad41",
	"./date.svg": "a2bf",
	"./dict.svg": "da75",
	"./documentation.svg": "ed00",
	"./drag.svg": "a2f6",
	"./druid.svg": "bc7b",
	"./education.svg": "2369",
	"./example.svg": "b6f9",
	"./guide.svg": "72d1",
	"./international.svg": "a601",
	"./list.svg": "3561",
	"./logininfor.svg": "9b2c",
	"./monitor.svg": "f71f",
	"./peoples.svg": "dc13",
	"./server.svg": "4738",
	"./system.svg": "922f",
	"./table.svg": "dc78",
	"./theme.svg": "7271",
	"./tool.svg": "06b3",
	"./tree-table.svg": "4d24",
	"./tree.svg": "0e8f",
	"./user.svg": "d88a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";